import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

// Tailwind scans templates for whole class names, so the tones are spelled out
// rather than built from the prop.

export default /*@__PURE__*/_defineComponent({
  __name: 'LlStatusBadge',
  props: {
    tone: { default: 'green' }
  },
  setup(__props: any) {

const TONES: Record<string, string> = {
  green: 'text-green-600 bg-green-50 border-green-600',
  red: 'text-red-700 bg-red-50 border-red-700',
  amber: 'text-amber-700 bg-amber-50 border-amber-700',
  grey: 'text-gray-600 bg-gray-50 border-gray-400',
};

const props = __props;

const toneClasses = computed(() => TONES[props.tone] ?? TONES.green);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["text-sm px-2 py-1 rounded-md border", toneClasses.value])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})